import React from 'react';
import './BrandLogo.css';

const src = `${process.env.PUBLIC_URL || ''}/brand-logo.png`;

const variants = {
  default: 'brand-logo--default',
  compact: 'brand-logo--compact',
  sidebar: 'brand-logo--sidebar',
  inline: 'brand-logo--inline',
  micro: 'brand-logo--micro',
};

/**
 * Primary "alter mirror" lockup (PNG in /public/brand-logo.png).
 * By default the image is shown as-is so PNG transparency reveals the page background.
 * Pass plate={true} for a soft beige chip behind the mark when you need extra contrast.
 */
export default function BrandLogo({
  variant = 'default',
  className = '',
  alt = 'alter mirror',
  plate = false,
  ...imgProps
}) {
  const v = variants[variant] || variants.default;
  const plateClass = plate
    ? `brand-logo-plate brand-logo-plate--${variant}`
    : 'brand-logo-plate brand-logo-plate--bare';
  return (
    <span className={`${plateClass} ${className}`.trim()}>
      <img
        src={src}
        alt={alt}
        className={`brand-logo ${v}`.trim()}
        decoding="async"
        {...imgProps}
      />
    </span>
  );
}
